import type { MyLeagueItem } from '@/types/leagues';

/** Filter duel-split leagues; system country league first, then original order. */
export function orderDuelOverlayLeagues(leagues: MyLeagueItem[]): MyLeagueItem[] {
  const eligible = leagues.filter(l => l.show_league_split_on_duels);
  const system: MyLeagueItem[] = [];
  const rest: MyLeagueItem[] = [];
  for (const league of eligible) {
    if (league.is_system) system.push(league);
    else rest.push(league);
  }
  return [...system, ...rest];
}

/**
 * Default active overlay league: country/system when present (ignores storedId),
 * otherwise last stored id if still eligible, else first in list.
 */
export function resolveDuelOverlayActiveLeagueId(
  leagues: MyLeagueItem[],
  storedId: string | null,
): string | null {
  if (leagues.length === 0) return null;
  const system = leagues.find(l => l.is_system);
  if (system) return system.id;
  if (storedId && leagues.some(l => l.id === storedId)) return storedId;
  return leagues[0].id;
}
